export function formatUrlQuery(baseUrl: string, entity: string, params: string[]) {
  return params.length > 0 ? `${baseUrl}?${entity}=${params.join(',')}` : baseUrl;
}
